import React from 'react';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';

const AlertDisplay = ({ alerts }) => {
  if (!alerts || alerts.length === 0) {
    return (
      <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          No alerts detected
        </Typography>
      </Box>
    );
  }

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString();
  };

  const getAlertIcon = (type) => {
    switch (type) {
      case 'error':
        return <ErrorIcon color="error" />;
      case 'warning':
        return <WarningIcon color="warning" />;
      case 'info':
      default:
        return <InfoIcon color="info" />;
    }
  };

  return (
    <Box sx={{ height: '100%' }}>
      <Typography variant="h6" gutterBottom>
        Proctoring Alerts
      </Typography>
      
      <List sx={{ overflow: 'auto', maxHeight: 'calc(100% - 40px)' }}>
        {alerts.map((alert, index) => (
          <React.Fragment key={index}>
            <ListItem alignItems="flex-start" sx={{ py: 1 }}>
              <ListItemIcon sx={{ minWidth: 40 }}>
                {getAlertIcon(alert.type)}
              </ListItemIcon>
              <ListItemText
                primary={alert.message}
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: 'block' }}
                      component="span"
                      variant="caption"
                      color="text.secondary"
                    >
                      {formatTimestamp(alert.timestamp)}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
            {index < alerts.length - 1 && <Divider variant="inset" component="li" />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default AlertDisplay; 